import React from "react"

import { useTranslation } from "react-i18next"

import Skeleton from "@mui/material/Skeleton"
import { Tag } from "@synapse-analytics/synapse-ui"

type Props = {
  modelState: string | undefined
  size?: "small" | "xsmall" | "default"
  skeletonWidth?: number
  margin?: number | string
}

export function ModelType(props: Props): React.ReactElement {
  const { modelState, size = "default", margin, skeletonWidth = 50 } = props
  const { t } = useTranslation("status")

  const animation: "wave" | "pulse" = "pulse"

  return (
    <React.Fragment>
      {modelState ? (
        <Tag
          size={size}
          // TODO:: refactor to use enums
          color={
            modelState === "challenger"
              ? "orange"
              : modelState === "live"
                ? "green"
                : modelState === "pending-action"
                  ? "yellow"
                  : "blue"
          }
          variant="filled"
          style={{ margin: margin }}
        >
          {modelState === "live"
            ? t("modelType.states.live")
            : modelState === "disabled"
              ? t("modelType.states.idle")
              : modelState === "pending-action"
                ? t("modelType.states.pendingAction")
                : t("modelType.states.challenger")}
        </Tag>
      ) : (
        <Skeleton width={skeletonWidth} animation={animation} style={{ display: "inline-block", margin: margin }} />
      )}
    </React.Fragment>
  )
}
